/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import {
  CheckboxWithDisplay as ConsumerCheckboxWithDisplay,
  CheckboxWithDisplayProps as ConsumerDisplayProps,
  colors,
} from '@blend/consumer-components';

export namespace DisplayProps {
  export interface Props extends Omit<ConsumerDisplayProps, 'color'> {}
}

export const CheckboxWithDisplay: React.FC<DisplayProps.Props> = ({ ...props }) => {
  return <ConsumerCheckboxWithDisplay {...props} color={colors.reflex} linksColor={colors.reflex} />;
};
